export default __webpack_public_path__ + "static/media/41.a6573808.png";